// Inicjalizacja Swipera dla product-card-slider
function initProductCardSliders() {
  document
    .querySelectorAll(".product-card-slider")
    .forEach(function (sliderEl) {
      var slidesCount = sliderEl.querySelectorAll(".swiper-slide").length;
      var isMobile = window.innerWidth < 750;
      // Zniszcz istniejącego Swipera, jeśli jest
      if (sliderEl.swiper) {
        sliderEl.swiper.destroy(true, true);
      }
      // Inicjalizuj Swipera
      new Swiper(sliderEl, {
        loop: slidesCount > 1,
        slidesPerView: 1,
        spaceBetween: 0,
        pagination:
          slidesCount > 1 && isMobile
            ? {
                el: sliderEl.querySelector(".swiper-pagination"),
                clickable: true,
              }
            : false,
        allowTouchMove: slidesCount > 1 && isMobile,
        navigation: false,
      });
    });
}
document.addEventListener("DOMContentLoaded", initProductCardSliders);
window.addEventListener("resize", function () {
  clearTimeout(window.__productCardSliderResizeTimeout);
  window.__productCardSliderResizeTimeout = setTimeout(
    initProductCardSliders,
    200
  );
});
